export const timeLabels = [
  "12A",
  ":15",
  ":30",
  ":45",
  "1A",
  ":15",
  ":30",
  ":45",
  "2A",
  ":15",
  ":30",
  ":45",
  "3A",
  ":15",
  ":30",
  ":45",
  "4A",
  ":15",
  ":30",
  ":45",
  "5A",
  ":15",
  ":30",
  ":45",
  "6A",
  ":15",
  ":30",
  ":45",
  "7A",
  ":15",
  ":30",
  ":45",
  "8A",
  ":15",
  ":30",
  ":45",
  "9A",
  ":15",
  ":30",
  ":45",
  "10A",
  ":15",
  ":30",
  ":45",
  "11A",
  ":15",
  ":30",
  ":45",
  "12P",
  ":15P",
  ":30P",
  ":45P",
  "1P",
  ":5P",
  ":30P",
  ":45P",
  "2P",
  ":15P",
  ":30P",
  ":45P",
  "3P",
  ":15P",
  ":30P",
  ":45P",
  "4P",
  ":15P",
  ":30P",
  ":45P",
  "5P",
  ":15P",
  ":30P",
  ":45P",
  "6P",
  ":15P",
  ":30P",
  ":45P",
  "7P",
  ":15P",
  ":30P",
  ":45P",
  "8P",
  ":15P",
  ":30P",
  ":45P",
  "9P",
  ":15P",
  ":30P",
  ":45P",
  "10P",
  ":15P",
  ":30P",
  ":45P",
  "11P",
  ":15P",
  ":30P",
  ":45P",
];
